import React, { useState, useEffect, useRef } from 'react';
import {
  ActionButtonWrapper,
  DescTitle,
  FilterSearch,
  FilterSearchWrap,
  InitialDownloadContent,
  LeftContentWrap,
  MainContent,
  MainTitleWrap,
  RadioOption,
  StoreNameText,
  TextItem,
  TopContent
} from './StepThreeStyle';
import { useAppStore } from 'stores/appStore';
import { Title, TitleDescription } from 'components/atoms';

import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RefreshIcon from '@mui/icons-material/Refresh';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineRounded from '@mui/icons-material/ErrorOutlineRounded';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

import {
  getInvalidToken,
  getProductListing,
  getStoreLocation,
  getVariationsList,
  postProductList,
  postRetryDownload,
  redownloadAllEmptySkus,
  saveNewSKUs,
  uploadNewSKUs
} from 'api/masterStore';
import { LiteGrid } from 'components/LiteGrid/LiteGrid';
import { Column, RowButton } from 'components/LiteGrid/DataGrid.types';
import { QueryParameters } from 'lib/types';
import { showAlert } from 'components/Alert';
import { Image } from 'components/Image/Image';
import { Button, CircularProgress, Grid, InputAdornment, TextField } from '@mui/material';
import { DeleteSVG, DownloadSVG, EditSVG, ImportSVG, SaveSVG, SearchSVG, UploadSVG } from 'assets/img';
import { AsyncButton } from 'components/ButtonNew/Button';
import { channelDetail, CHANNELS } from 'shared/constants';
import { ChannelDetail } from 'interfaces/Channels';
import { ModalAction } from 'components/ModalAction/ModalAction';
import { useForm } from 'react-hook-form';
import Box from '@mui/material/Box';
import LineProgress from 'components/LineProgress';
import SelectButton, { SelectButtonItemProps } from 'components/SelectButton/SelectButton';
import withModalIntegration from 'views/withModalIntegration';
import { CheckCircleOutline } from '@mui/icons-material';
import { ModalImportSKU, ResponseImport } from 'components/ModalImport/ModalImportSKU';
import HeaderProgress from './HeaderProgress';
import LightTooltip from 'components/LightTooltip';

interface FormValues {
  q: string;
}

interface OtherFilterProps {
  status?: string | null;
  type?: string | null;
}

type StatusProgressType =
  | 'idle'
  | 'downloading'
  | 'counting'
  | 'uploading'
  | 'uploaded'
  | 'importing'
  | 'imported'
  | 'finished'
  | 'import_failed';
  
export const getWordingErrorMsg = (err: any) => {
  // karakter melebihi batas maximal
  if (err.includes('SKU length exceeds')) {
    return 'Karakter SKU melebihi batas maximal 50 karakter';
  }
  return err;
}

const InitialDownload = (props: any) => {
  const query = useRef<QueryParameters>();
  const refresher = useRef<() => void>();
  const setQuery = useRef<(e: QueryParameters) => QueryParameters>();
  const { setCompleteValidation, openModal } = props;
  const [busy, setBusy] = useState(false);
  const [deletingItem, setDeletingItem] = useState([]);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [sku, setSku] = useState('all');
  const [statusDownload, setStatusDownload] = useState('all');
  const [detailStore, setDetailStore] = useState<any>({});
  const { setActiveStep, setDisablePrevButton, canSkip, cantSkip, setValidationComplete, setChannelIdOto } =
    useAppStore();
  const [downloadState, setDownloadState] = useState('idle');
  const [totalDownloaded, setTotalDownloaded] = useState(0);
  const [downloadPercentage, setDownloadPercentage] = useState(0);
  const [totalProduct, setTotalProduct] = useState(0);
  const [isError, setIsError] = useState(false);
  const [emptySkus, setEmptySkus] = useState(null);
  const [isEditingColumnSKU, setIsEditingColumnSKU] = useState<boolean>(false);
  const [changedSKUs, setChangedSKUs] = useState(new Map<string, { newItemCode: string, itemCode: string; prevItemCode?: string }>());
  const [isShowModalImport, setIsShowModalImport] = useState(false);
  const allowedEditSKUChannels = [CHANNELS.SHOPEE, CHANNELS.TIKTOK, CHANNELS.LAZADA];
  const currentProgress = useRef<StatusProgressType>('idle');
  const importResult = useRef<Partial<ResponseImport>>({});


  const { register, handleSubmit, setValue, getValues } = useForm<FormValues>({
    defaultValues: {
      q: ''
    }
  });

  const handleChangeStatusDownload = (event: React.ChangeEvent<HTMLInputElement>) => {
    setStatusDownload((event.target as HTMLInputElement).value);
  };
  const handleChangeSKU = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSku((e.target as HTMLInputElement).value);
  };

  const getStoreDetail = async () => {
    try {
      const res = await getStoreLocation(props.data);
      setDetailStore(res.data);
    } catch (err) {
      const error = err as Error;
      console.log(error);
      showAlert('error', `${error}`, 5000);
    }
  };

  const handleActionTable = async (data) => {
    try {
      setBusy(true);
      const mapData: any = Array.isArray(data) ?
        data : [data]
      const ids = Array.isArray(mapData) ?
        mapData.map((row) => row.channel_group_id) : [mapData[0].channel_group_id];
      let payload = {
        channelId: mapData[0].channel_id,
        storeId: mapData[0].store_id,
        isMaster: mapData[0].is_master,
        ids
      };
      const res: any = await postRetryDownload(payload);
      if (res.status === 200) {
        refresher.current();
        showAlert('success', 'Berhasil download ulang');
      }
    } catch (err) {
      const error = err as Error;
      console.log(error);
      showAlert('error', `${error}`, 5000);
    }
  };

  const handleDelete = async (data) => {
    const newData = [];
    for (let idx = 0; idx < data.length; idx++) {
      const o = data[idx] as any;
      let result: any = {
        indx: idx,
        id: o.channel_item_id ? o.channel_item_id : o.channel_group_id,
        label: `${o.item_name}`,
        channelId: o.channel_id,
        storeId: o.store_id,
        isMaster: false,
        busy: null,
        success: null,
        isVariant: true,
        skus: [
          {
            item_code: o.item_code
          }
        ]
      };

      if (o.is_error) {
        const variations = await getVariationsList(o.channel_id, o.store_id, o.channel_group_id);
        result.skus = variations.data.data[0].skus;
        result.isVariant = false;
        result.id = o.channel_group_id;
      }

      newData.push(result);
    }

    setDeletingItem(newData);
    setDeleteConfirmation(true);
  };

  useEffect(() => {
    setDisablePrevButton(true);
    getStoreDetail();
  }, []);

  const renderProduct = (
    _cellData: undefined,
    rD: { img_url: string; item_name: string; item_code: string; is_bundle: boolean; item_id: string }
  ) => {
    const name = rD && rD.item_name && rD.item_name.length > 30 ? `${rD.item_name.slice(0, 30)}...` : rD && rD.item_name;
    return (
      <div className="d-flex align-items-center font-size-table">
        <Image src={rD.img_url} height={52} width={52} className="border 1 border-light-gray rounded-sm mt-1 mb-1" />
        <div className="d-flex flex-column ml-3">
        <LightTooltip title={rD.item_name} arrow>
          <span className="text-nowrap">{name}</span>
        </LightTooltip>
          {!allowedEditSKUChannels.includes(detailStore?.channel_id) && (
            <span className="text-nowrap">{rD.item_code}</span>
          )}
        </div>
      </div>
    );
  };

  const columns: Column[] = [
    {
      header: 'Produk',
      binding: 'item_name',
      format: 'string',
      allowSorting: true,
      freezeCol: true,
      template: renderProduct
    },
    ...(allowedEditSKUChannels.includes(detailStore?.channel_id) ? [{
      header: 'SKU',
      binding: 'item_code',
      format: 'string',
      allowSorting: true,
      template: (row, data) => {
        return (
          <div className="d-flex align-items-center" style={{ minWidth: '200px' }}>
            {!isEditingColumnSKU ? (
              <span className="font-weight-normal">{data.item_code}</span>
            ) : (
              <TextField
                placeholder="Masukkan SKU"
                defaultValue={changedSKUs.get(`${row.row_id}`) || data.item_code}
                onFocus={(e) => {
                  const newSKUs = new Map(changedSKUs);
                  newSKUs.set(`${data.channel_item_id}`, {
                    prevItemCode: data.item_code,
                    newItemCode: e.target.value,
                    itemCode: data.channel_item_id
                  });
                  setChangedSKUs(newSKUs);
                }}
                onBlur={(e) => {
                  const newSKUs = new Map(changedSKUs);
                  const existSKU = newSKUs.get(`${data.channel_item_id}`);
                  newSKUs.set(`${data.channel_item_id}`, {
                    ...existSKU,
                    newItemCode: e.target.value,
                    itemCode: data.channel_item_id,
                  });
                  setChangedSKUs(newSKUs);
                }}
                inputProps={{ maxLength: 50 }}
              />
            )}
          </div>
        );
      }
    }] as Column[] : []),
    {
      header: 'Status Download',
      headerClassName: 'text-center text-second text-nowrap',
      width: 240,
      allowSorting: false,
      binding: 'status',
      template: (row, data) => {
        const renderProgress = () => {
          if (data.status === 'failed') {
            return (
              <LightTooltip
                title={
                  data.error_message.includes('Cannot read property')
                    ? 'Kesalahan pada server'
                    : `${data.error_message}`
                }
                placement="bottom"
                arrow
              >
                <ErrorOutlineRounded fontSize="medium" className="text-danger" />
              </LightTooltip>
            );
          } else if (data.status === 'downloaded') {
            return <CheckCircleOutline fontSize="medium" style={{ color: '#4CAF50' }} />;
          } else if (data.status === 'waiting') {
            return <CircularProgress size={24} />;
          } else {
            return <WarningAmberIcon fontSize="medium" style={{ color: 'rgb(255, 152, 0)' }} />;
          }
        };
        return <div className="text-center py-2">{renderProgress()}</div>;
      }
    },
    ...(allowedEditSKUChannels.includes(detailStore?.channel_id) ? [
      {
        header: 'Status Channel Upload',
        headerClassName: 'text-center text-second text-nowrap',
        width: 240,
        allowSorting: false,
        binding: 'status_upload',
        template: (row, data) => {
          const renderProgress = () => {
            if (data.status_upload === 'uploading') {
              return <CircularProgress size={24} />;
            } else if (data.status_upload === 'uploaded') {
              return <CheckCircleOutline fontSize="medium" style={{ color: '#4CAF50' }} />;
            } else if (data.upload_error_message) {
              return <ErrorOutlineRounded fontSize="medium" className="text-danger" />;
            } else {
              return <span>-</span>;
            }
          };
          return <div className='text-center'>{renderProgress()}</div>
        }
      }
    ] : [])
  ];

  const getQuery = (q: QueryParameters) => {
    query.current = q;
  };

  const getSetQuery = (fn) => {
    setQuery.current = fn;
  };

  const validationCheck = async (state) => {
    if (state === 'finished') {
      setCompleteValidation('DOWNLOADED');
    }

    const getEmptySku = await getProductListing(props.data, { page: 1, pageSize: 10, type: 1, q: '' });
    const response = getEmptySku.data.data;
    setEmptySkus(response);
    const emptySkusFound = Number(response.count) > 0;
    if (!emptySkusFound && state === 'finished') {
      setCompleteValidation('VALID_SKU');
      setValidationComplete(true);
    }

    const getDuplicateSku = await getProductListing(props.data, { page: 1, pageSize: 10, type: 3, q: '' });
    const responseDuplicate = getDuplicateSku.data.data;
    const duplicateSkuFound = Number(responseDuplicate.count) === 0;
    if (duplicateSkuFound) {
      setCompleteValidation('DUPLICATE_SKU');
    }
  };

  const onCheckInvalidToken = async (storeId) => {
    const res = await getInvalidToken(storeId);

    if (res.data[0].invalid_token) {
      setIsError(res.data[0].invalid_token);
    } else {
      return;
    }
  };

  const getFetcher = async (options: QueryParameters) => {
    setBusy(true);
    const res = await getProductListing(props.data, options);
    const responseData = res?.data || null;

    let responseProductCount = Number(responseData.data?.count);
    setTotalProduct(responseProductCount);
    setTotalDownloaded(Math.floor(Number(responseData.data?.count) * (responseData.data?.percent / 100)));

    const data = {
      ...res,
      data: responseData?.data?.products || [],
      totalCount: responseData?.data?.count || '0'
    };

    let currentStatus = null;
    const importRunning = responseData?.data?.import_progress?.percent < 100 && responseData?.data?.import_progress?.importing > 0;
    const uploadRunning = responseData?.data?.upload_progress?.percent < 100 && responseData?.data?.upload_progress?.uploading > 0;

    if (currentProgress.current === 'importing' || importRunning) {
      // import logic
      // const importFinished = responseData?.data?.import_progress?.percent === 100
      const importFail = importResult.current.failed > 0 || (responseData?.data?.import_progress?.percent < 100 && responseData?.data?.import_progress?.failed > 0);
      currentStatus = importFail ? 'import_failed' : importRunning ? 'importing' : 'imported';
      if (['import_failed', 'imported'].includes(currentStatus)) setBusy(false)

      responseProductCount = Number(responseData.data?.import_progress?.importing) + Number(responseData.data?.import_progress?.imported) + Number(responseData.data?.import_progress?.failed);
      setTotalProduct(responseProductCount);
      setTotalDownloaded(Number(responseData.data?.import_progress?.imported));
      setDownloadPercentage(responseData.data?.import_progress?.percent);
      setDownloadState(currentStatus);
    } else if (currentProgress.current === 'uploading' || uploadRunning) {
      // upload logic
      const uploadFinished = responseData?.data?.upload_progress?.percent === 100
      const uploadFail = responseData?.data?.upload_progress?.percent < 100 && responseData?.data?.upload_progress?.failed > 0;
      currentStatus = uploadFinished ? 'uploaded' : uploadFail ? 'failed' : uploadRunning ? 'uploading' : 'uploading';
      if (currentStatus === 'uploaded') setBusy(false)

      responseProductCount = Number(responseData.data?.upload_progress?.uploading) + Number(responseData.data?.upload_progress?.uploaded) + Number(responseData.data?.upload_progress?.failed);
      setTotalProduct(responseProductCount);
      setTotalDownloaded(responseData.data?.upload_progress?.uploaded);
      setDownloadPercentage(responseData.data?.upload_progress?.percent);
      setDownloadState(currentStatus);
    } else {
      const downloadFinished =
        responseData?.state === 'idle' &&
        responseData?.data.count > 0 &&
        responseData?.data?.percent >= 100

      currentStatus =
        downloadFinished ? 'finished' : responseData?.state;
      if (currentStatus === 'finished') setBusy(false)
      await validationCheck(currentStatus);
      setDownloadPercentage(responseData.data?.percent);
      setDownloadState(currentStatus);
      setBusy(prev => {
        if (prev === true) return false;
        return prev;
      })
    }
    currentProgress.current = currentStatus;

    if (
      (responseProductCount > 0 && 
        ['finished', 'uploaded', 'imported', 'import_failed'].includes(currentStatus)) ||
      currentStatus === 'idle'
    ) {
      canSkip();
    } else {
      cantSkip();
    }
    if (currentStatus === 'idle' || currentStatus === 'finished') {
      onCheckInvalidToken(detailStore.store_id ?? props.data);
    }
    return data;
  };

  const fetcher = React.useMemo(() => {
    return (options: QueryParameters) => {
      return getFetcher(options);
    };
  }, []);

  function handleRowAction(item: any, binding, index) { }

  const isRowLocked = (row) => {
    if (row.status === 'waiting' && downloadState !== 'finished' || isEditingColumnSKU || row.status === 'failed') {
      return true;
    } else if (downloadState === 'finished' && row.status !== 'downloaded') {
      return false;
    } else {
      return false;
    }
  };

  const lazadaEmptySKU = (data) => {
    return (data.channel_id === CHANNELS.LAZADA && data.item_code?.split('-').includes(data.channel_group_id)) || false
  }

  const uploadSkuMarketplace = async (data) => {
    try {
      // except row with status failed or empty item_code
      const valid = data.every((row) => row.status !== 'failed' && row.item_code && !lazadaEmptySKU(row));
      if (!valid) {
        showAlert(
          'warning',
          'Data Produk tidak Valid',
          undefined,
          'Saat ini, proses upload tidak dapat dilanjutkan, Silahkan cek kembali data produk Anda.\n Terdapat beberapa produk dengan sku kosong atau gagal download.',
          'modal'
        );
        return;
      }

      const ids = data.map((row) => row.channel_item_id);
      const res: any = await uploadNewSKUs({
        channelGroupIds: [],
        channelItemIds: ids,
        storeId: detailStore.store_id
      });
      showAlert('success', res.data.message);
      currentProgress.current = 'uploading';
      setDownloadState('uploading');
      refresher.current?.()
    } catch (err) {
      const error = err;
      console.log(String(error));
    }
  }

  const rowButton: RowButton<any>[] = [
    {
      text: 'Download Ulang',
      icon: <DownloadSVG fill='#163A50' />,
      iconHeaderWithText: true,
      action: handleActionTable
    },
    ...(allowedEditSKUChannels.includes(detailStore?.channel_id) ? [
      {
        text: 'Upload ke Marketplace',
        icon: <UploadSVG />,
        iconHeaderWithText: true,
        action: uploadSkuMarketplace,
        disabled: (row) => {
          return row.status === 'failed' || !row.item_code;
        }
      }
    ] : [])
  ];

  const handleReset = async () => {
    const newQuery: QueryParameters & OtherFilterProps = {
      ...query.current,
      q: '',
      page: 1
    };

    newQuery.status = '';
    newQuery.type = '';

    setValue('q', '');
    setStatusDownload('all');
    setSku('all');

    setQuery.current(newQuery);
  };

  const handleSubmitSearch = async (formvalue) => {
    const newQuery: QueryParameters & OtherFilterProps = {
      ...query.current,
      q: formvalue.q,
      page: 1
    };

    newQuery.type = sku === 'all' ? '' : sku;
    newQuery.status = statusDownload === 'all' ? '' : statusDownload;

    setQuery.current(newQuery);
  };

  const handleDownloadAll = async () => {
    try {
      const res = await postProductList(detailStore.channel_id, detailStore.store_id, true, false);
      if (res.data.status === 'ok') {
        showAlert('success', `${res.data.message}`, 5000);
        refresher.current();
      }
    } catch (err) {
      const error = err as Error;
      console.log(error);
      showAlert('error', `${error}`, 5000);
    }
  };

  const handleDownloadEmptySku = async () => {
    try {
      const storeId = detailStore.store_id;
      const res: any = await redownloadAllEmptySkus(storeId, detailStore.channel_id, true);
      if (res.data.status === 'ok') {
        showAlert('success', `${res.data.message}`, 5000);
        refresher.current();
      }
    } catch (err) {
      const error = err as Error;
      console.log(error);
      showAlert('error', `${error}`, 5000);
    }
  };



  const onDeleteClose = async () => {
    setDeleteConfirmation(false);
    refresher.current();
  };

  const channels = channelDetail as ChannelDetail;

  useEffect(() => {
    let intervalId: ReturnType<typeof setInterval> | null = null;

    const activeStates = ['downloading', 'counting', 'uploading', 'importing'];

    if (activeStates.includes(downloadState)) {
      intervalId = setInterval(() => {
        refresher.current?.();
      }, 10000);
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [downloadState]);

  const handleOtoriation = () => {
    setChannelIdOto(detailStore.channel_id);
    setDisablePrevButton(true);
    cantSkip();
    setActiveStep(2);
  };

  const downloadButtonStatus = busy || downloadState === 'downloading' || downloadState === 'counting';
  // const titleText = downloadState === 'downloading' || downloadState === 'counting' ? 'Proses' : 'Selesai';
  const progressLabel = {
    downloading: 'Sedang Mendownload',
    uploading: 'Sedang Mengupload',
    uploaded: 'Selesai Mengupload',
    importing: 'Sedang Mengimpor',
    imported: 'Selesai Mengimpor',
    import_failed: 'Gagal Mengimpor'
  }


  const downloadOptions: SelectButtonItemProps[] = [
    {
      label: 'Download Semua Produk',
      handler: () => handleDownloadAll(),
      icon: <DownloadSVG fill="#163A50" />,
      desc: 'Download  seluruh data produk yang ada di toko.'
    },
    {
      label: 'Download Produk SKU Kosong',
      handler: () => handleDownloadEmptySku(),
      icon: <DownloadSVG fill="#163A50" />,
      desc: 'Download daftar produk yang belum memiliki SKU untuk memudahkan pengecekan dan pembaruan data.'
    }
  ];

  return (
    <div>
      <InitialDownloadContent>
        <TopContent>
          <div className="d-flex align-items-center">
            {channels[detailStore?.channel_id]?.channelLogo && (
              <Image
                height={25}
                width='auto'
                src={channels[detailStore?.channel_id]?.channelLogo}
                className="rounded-sm mt-2 mb-2"
              />
            )}
            <StoreNameText font_size="14px">{detailStore?.store_name}</StoreNameText>
            {isError && (
              <LightTooltip
                title={
                  <span>
                    Toko ini perlu otorisasi ulang.{' '}
                    <span className="text-link" onClick={() => {
                      openModal(detailStore);
                    }}>
                      Klik disini
                    </span>{' '}
                    untuk melakukan otorisasi ulang toko
                  </span>
                }
                placement="bottom"
                arrow
              >
                <ErrorOutlineRounded fontSize="medium" className="text-danger ml-2" />
              </LightTooltip>
            )}
          </div>
          <ActionButtonWrapper>
            {allowedEditSKUChannels.includes(detailStore?.channel_id) && (
              <AsyncButton
                onClick={async () => {
                  setIsShowModalImport(true);
                }}
                variant="outlined"
                type="button"
                color="inherit"
                className="px-4"
                startIcon={<ImportSVG />}
              >
                Import
              </AsyncButton>
            )}
            <SelectButton label={'Download'} busy={downloadButtonStatus} options={downloadOptions} />
          </ActionButtonWrapper>
        </TopContent>
        {/* <MainContent>
          <MainTitleWrap>
            <div>
              <Title>
                {titleText} Mendownload Produk dari {detailStore?.store_name}
              </Title>
              {busy ? (
                <TitleDescription>{`${totalProduct} produk`}</TitleDescription>
              ) : (
                <TitleDescription>{`${totalDownloaded} dari ${totalProduct}`}</TitleDescription>
              )}
            </div>
          </MainTitleWrap>
        </MainContent> */}
        <HeaderProgress
          progress={downloadPercentage}
          data={{
            storeName: detailStore?.store_name,
            countProducts: totalProduct,
            countProgressProducts: totalDownloaded
          }}
          progressLabel={progressLabel[downloadState]}
          isFailed={['import_failed', 'failed'].includes(downloadState)}
        />
        {downloadState === 'import_failed' ? (
          <Box sx={{ width: '100%' }}>
            <div className="text-danger" style={{ fontSize: '14px' }}>
              {importResult.current.errors?.map((err, index) => (
                <p key={index} className="text-danger mb-1">
                  <span>{`Baris ${err.row}: `}</span>{' '}
                  <span>{`${getWordingErrorMsg(err.error)}`}</span>
                </p>
              ))}
            </div>
          </Box>
        ) : emptySkus?.count > 0 && (
          <Box sx={{ width: '100%' }}>
            <div className="text-danger" style={{ fontSize: '14px' }}>
              Terdapat {emptySkus.count} produk tanpa SKU.{' '}
            </div>
          </Box>
        )}
      </InitialDownloadContent>

      <Grid container spacing={3}>
        <Grid item md={12}>
          {/* <Box sx={{ width: '100%' }}>
            <LineProgress value={downloadPercentage} />
          </Box>
          {emptySkus?.count > 0 && (
            <Box sx={{ width: '100%' }}>
              <div className="text-danger" style={{ fontSize: '14px' }}>
                Terdapat {emptySkus.count} produk tanpa SKU.{' '}
                <span onClick={handleDownloadEmptySku} className="text-primary cursor-pointer">
                  Silahkan edit SKU di Seller Center kemudian klik disini untuk mendownload ulang.
                </span>
              </div>
            </Box>
          )} */}
        </Grid>
        <Grid item md={3}>
          <LeftContentWrap>
            <form onSubmit={handleSubmit(handleSubmitSearch)}>
              <FilterSearch>
                <FilterSearchWrap>
                  <p className="m-0">Filter</p>
                  <AsyncButton
                    color="inherit"
                    type="button"
                    className="text-danger px-0 hover-none"
                    onClick={handleReset}
                    disabled={busy || isEditingColumnSKU}
                  >
                    Reset
                  </AsyncButton>
                </FilterSearchWrap>
                <TextField
                  disabled={busy}
                  variant="outlined"
                  size="small"
                  className="bg-white rounded-sm no-notch mb-3"
                  placeholder="Cari Produk, SKU Produk"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchSVG />
                      </InputAdornment>
                    )
                  }}
                  {...register('q')}
                />
              </FilterSearch>
              <RadioOption>
                <DescTitle>Status Download</DescTitle>
                <FormControl>
                  <RadioGroup value={statusDownload} onChange={handleChangeStatusDownload}>
                    <FormControlLabel
                      disabled={busy}
                      value="all"
                      className="mb-1"
                      control={<Radio sx={{ padding: '2px', marginLeft: '10px' }} size="small" />}
                      label={<TextItem>Semua</TextItem>}
                    />
                    <FormControlLabel
                      disabled={busy}
                      value="failed"
                      className="mb-1"
                      control={<Radio sx={{ padding: '2px', marginLeft: '10px' }} size="small" />}
                      label={<TextItem>Gagal Download</TextItem>}
                    />
                  </RadioGroup>
                </FormControl>
              </RadioOption>
              <RadioOption>
                <DescTitle>Kelengkapan SKU Produk</DescTitle>
                <FormControl>
                  <RadioGroup value={sku} onChange={handleChangeSKU}>
                    <FormControlLabel
                      disabled={busy}
                      value="all"
                      className="mb-1"
                      control={<Radio sx={{ padding: '2px', marginLeft: '10px' }} size="small" />}
                      label={<TextItem>Semua Produk</TextItem>}
                    />
                    <FormControlLabel
                      disabled={busy}
                      value="2"
                      className="mb-1"
                      control={<Radio sx={{ padding: '2px', marginLeft: '10px' }} size="small" />}
                      label={<TextItem>Produk dengan SKU Produk</TextItem>}
                    />
                    <FormControlLabel
                      disabled={busy}
                      value="1"
                      className="mb-1"
                      control={<Radio sx={{ padding: '2px', marginLeft: '10px' }} size="small" />}
                      label={<TextItem>Tidak ada SKU Produk</TextItem>}
                    />
                    <FormControlLabel
                      disabled={busy}
                      value="3"
                      className="mb-1"
                      control={<Radio sx={{ padding: '2px', marginLeft: '10px' }} size="small" />}
                      label={<TextItem>SKU Duplikat</TextItem>}
                    />
                  </RadioGroup>
                </FormControl>
              </RadioOption>
              <div className="mt-3">
                <AsyncButton fullWidth type="submit" color="primary" disabled={busy || isEditingColumnSKU}>
                  Terapkan
                </AsyncButton>
              </div>
            </form>
          </LeftContentWrap>
        </Grid>
        <Grid item md={9}>
          {allowedEditSKUChannels.includes(detailStore?.channel_id) && (
            <div
              className='d-flex align-items-center justify-content-end'
              style={{ marginBottom: '28.5px' }}
            >
              {isEditingColumnSKU ? (
                <Button
                  variant='contained'
                  color="primary"
                  startIcon={<SaveSVG />}
                  disabled={busy}
                  onClick={() => {
                    canSkip()
                    setIsEditingColumnSKU(false)
                    // get all changed SKUS
                    const saveAllChangedSKUs = []
                    changedSKUs.forEach(async (value) => {
                      if (value.newItemCode.trim() !== value.prevItemCode?.trim()) {
                        saveAllChangedSKUs.push(
                          saveNewSKUs({ newItemCode: value.newItemCode, itemCode: value.itemCode }, detailStore?.store_id)
                        )
                      }
                    })
                    const saveResults = Promise.all(saveAllChangedSKUs);
                    saveResults.then(() => {
                      setIsEditingColumnSKU(false)
                      setChangedSKUs(new Map<string, { newItemCode: string, itemCode: string }>());

                      const newQuery: QueryParameters & OtherFilterProps = {
                        ...query.current,
                        type: '2',
                      };
                      setSku('2');
                      setQuery.current(newQuery);
                      showAlert('success', 'Berhasil menyimpan perubahan SKU');
                    }).catch((error) => {
                      setIsEditingColumnSKU(false)
                      setChangedSKUs(new Map<string, { newItemCode: string, itemCode: string }>());
                      console.error('Error saving SKUs:', error);
                      showAlert('error', 'Gagal menyimpan perubahan SKU. Silakan coba lagi.', 5000);
                    });
                  }}
                >
                  Simpan
                </Button>
              ) : (
                <Button
                  variant='contained'
                  color="primary"
                  disabled={busy}
                  startIcon={<EditSVG className='text-white' />}
                  onClick={() => {
                    setIsEditingColumnSKU(true)
                    cantSkip();
                  }}
                >
                  Edit
                </Button>
              )}
            </div>
          )}
          <LiteGrid
            showToolbar
            columns={columns}
            data={fetcher}
            busy={busy}
            showRowSelect
            getRefresher={(e) => (refresher.current = e)}
            rowButton={rowButton}
            getQuery={getQuery}
            getSetQuery={getSetQuery}
            onRowAction={handleRowAction}
            isRowLocked={isRowLocked}
            gridName="initial_download_grid"
            customHeight="calc(100vh - 327px)"
            allowDelete
            // useConfirmDelete={false}
            onDelete={(deleted) => handleDelete(deleted)}
            havePagination={isEditingColumnSKU ? false : true}
            isEmpty={
              statusDownload === 'all' && downloadState === 'idle'
                ? 'Produk yang belum ada disini akan di refresh oleh sistem per 10 detik atau silakan klik refresh untuk meloading data yang sudah terdownload.'
                : ''
            }
          />
        </Grid>
      </Grid>
      <ModalAction
        title="Hapus"
        method="POST"
        urlApi={'product/delete-onboarding-products'}
        btnSubmitColor="primary"
        mappingRequest={(data) => ({ ids: [data.channel_group_id] })}
        data={deletingItem}
        onClose={onDeleteClose}
        isShow={deleteConfirmation}
      />
      <ModalImportSKU
        data={{ storeId: detailStore?.store_id ?? 0, type: sku, itemName: getValues('q') }}
        open={isShowModalImport}
        onClose={(e, reason, result) => {

          if (!reason && result.success) {
            setBusy(true);
            setTotalDownloaded(result.success);
            setDownloadState('importing')
            currentProgress.current = 'importing';
            setDownloadPercentage((result.total_rows / result.success) * 100)
            importResult.current = result;
            setTimeout(() => {
              refresher.current?.();
            }, 50)
          } else {
            if (result) {
              setTotalDownloaded(0);
              setTotalProduct(0);
              setDownloadState('import_failed')
              currentProgress.current = 'import_failed';
              setDownloadPercentage(100);
              importResult.current = {
                ...importResult.current,
                failed: result?.errors?.length || 0,
                total_rows: 0,
                errors: result?.errors || []
              };
            }
          }
          setIsShowModalImport(false)
        }} />
    </div>
  );
};

export default withModalIntegration(InitialDownload, true);
